<template>
  <div class="cal" :class="{'cal--is-dayview': isDayView}">
    <div v-show="load" class="full-spinner">
      <div class="icon-docendo animated pulse infinite"></div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'  // eslint-disable-line no-unused-vars
import fc from 'fullcalendar' // eslint-disable-line no-unused-vars
import moment from 'moment' // eslint-disable-line no-unused-vars
import config from '../../config' // eslint-disable-line no-unused-vars

export default {
  props: {
    calendarId: {
      default: null
    },
    caldate: {
      default: () => config.now
    },
    events: {
      type: Array,
      default: () => []
    },
    viewState: {
      type: Number,
      default: 0
    },
    locale: {
      default: window.USER && window.USER.locale ? window.USER.locale : 'en'
    },
    i18n: {}
  },
  computed: {
    calendarDate () {
      return this.caldate
    },
    calendarViewState () {
      const state = this.viewState * 1
      if (window.SCHOOL && window.SCHOOL.id === 56058) {
        return {
          minTime: '08:00:00',
          maxTime: '20:00:00',
          showWeekends: true
        }
      }
      if (state === 0) {
        return {
          minTime: '06:00:00',
          maxTime: '18:00:00',
          showWeekends: false
        }
      } else if (state === 1) {
        return {
          minTime: '06:00:00',
          maxTime: '18:00:00',
          showWeekends: true
        }
      } else {
        return {
          minTime: '00:00:00',
          maxTime: '24:00:00',
          showWeekends: true
        }
      }
    }
  },
  data () {
    return {
      load: true,
      isDayView: false
    }
  },
  watch: {
    events (value) {
      this.load = false
      this.updateEvents()
    },
    caldate () {
      this.goToDate()
    },
    calendarViewState () {
      this.cal.fullCalendar('destroy')
      this.fullCalendar()
    },
    locale (val) {
      this.updatelocale(val)
    }
  },
  methods: {
    updatelocale (val) {
      const timeFormat = 'LT'
      this.cal.fullCalendar('option', {
        'locale': val,
        'slotLabelFormat': timeFormat,
        columnHeaderText (mom) {
          // NN HACK
          if (val === 'nn' || val === 'nb') {
            return moment(mom).format('dddd DD/MM')
          }
          try {
            return moment(mom).local().toDate().toLocaleDateString(val, {
              weekday: 'long',
              month: '2-digit',
              day: '2-digit'
            })
          } catch (e) {
            return moment(mom).format('LL')
          }
        }
      })
      this.updateEvents()
    },
    goToDate () {
      this.cal.fullCalendar('gotoDate', moment(this.caldate))
    },
    updateEvents () {
      this.cal.fullCalendar('removeEvents')
      this.cal.fullCalendar('addEventSource', this.events)
    },
    fullCalendar () {
      const calIdsWithSundayFirst = [268587, 268583, 268581, 268588, 268575, 268585, 268577, 268579]
      const firstDay = this.calendarId && calIdsWithSundayFirst.indexOf(this.calendarId) > -1 ? 0 : 1
      const self = this
      self.cal = $(self.$el)
      self.cal.fullCalendar({
        schedulerLicenseKey: '0561574571-fcs-1494418560',
        locale: window.use_i18n.locale,
        minTime: this.calendarViewState.minTime,
        maxTime: this.calendarViewState.maxTime,
        allDaySlot: false,
        height: 'auto',
        weekends: this.calendarViewState.showWeekends,
        editable: false,
        droppable: false,
        firstDay: firstDay,
        timezone: 'local',
        events: this.allEvents,
        defaultView: 'agendaWeek',
        timeFormat: 'LT',
        slotLabelFormat: 'LT',
        header: {
          left: '',
          right: ''
        },
        columnHeaderText (mom) {
          try {
            return moment(mom).local().toDate().toLocaleDateString(self.locale, {
              weekday: 'long',
              month: '2-digit',
              day: 'numeric'
            })
          } catch (e) {
            return moment(mom).format('LL')
          }
        },
        eventClick (event, view) {
          self.$emit('eventclick', event)
        },
        eventRender (event, element) {
          let teachersString = event.duration > 20
            ? '<p class="title__meta"><span class="icon-user"> </span>' + event.teacher + '</p>'
            : ', <span class="marg-5-left"> </span> <span class="icon-user"></span> ' + event.teacher + '</span>'

          if (event.group) {
            element.find('.fc-title').append('<p class="title__meta"><span class="icon-users"> </span>' + event.group + '</p>')
          }

          if (event.teacher) {
            element.find('.fc-title').append(teachersString)
          }

          if (event.room) {
            element.find('.fc-title').append('<p class="title__meta"><span class="icon-location"> </span>' + event.room + '</p>')
          }

          if (event.has_notes) {
            element.find('div.fc-time').prepend('<span class="right icon-file-text2"></span>')
          }

          if (event.away) {
            element.addClass('d-event-outside-school')
          }

          if (event.canceled) {
            const str = self.i18n && self.i18n.canceled ? self.i18n.canceled : 'Canceled'
            element.addClass('d-event--canceled')
            element.attr('data-label', str) // ← Her sætter vi attributten
          }
        }
      })
      self.$nextTick(() => {
        this.goToDate()
        this.$emit('view', this.cal.fullCalendar('getView'))
        if (window.location.href && window.location.href.indexOf('?day') > -1) {
          this.cal.fullCalendar('changeView', 'agendaDay', moment())
          this.cal.fullCalendar('option', 'minTime', '07:45:00')
          this.cal.fullCalendar('option', 'maxTime', '14:30:00')
        }
      })
    }
  },
  beforeMount () {
    if (window.location.href && window.location.href.indexOf('?day') > -1) {
      this.isDayView = true
    }
  },
  mounted () {
    this.fullCalendar()
  }
}
</script>

<style>
@import '../../../node_modules/fullcalendar/dist/fullcalendar.min.css';
@import '../../assets/css/variables.css';

#monthname {
  display: flex;
  font-size: 1.4rem;
  align-items: center;
  padding-left: 20px;
}

.public-app .fc-unthemed .fc-today {
  background: var(--active-blue);
}

.public-app .fc-v-event {
  cursor: pointer;
  min-height: 10px;
}

.public-app .fc-header-toolbar {
  display: none;
}

.public-app .fc-time-grid .fc-slats td {
  height: 2em;
}

.public-app .cal--is-dayview .fc-time-grid .fc-slats td {
  height: 4em;
}

.public-app .cal--is-dayview .fc-time-grid-event .fc-time {
  float: right;
}

.fc-event-vert {
  min-height: 25px;
}

.fc-button {
  cursor: pointer;
  display: inline-block;
  text-align: center;
  padding: 2px 10px;
  font-weight: bold !important;
  height: 28px;
  background-color: #f6f7f8;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  color: #2c3e50;
  text-shadow: none !important;
  box-shadow: none !important;
  background-image: none !important;
}

.marg-5-left {
  margin-left: 5px;
}

.full-spinner {
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.5);
  width: 100%;
  height: 100%;
  min-height: 800px;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 100px;
  color: var(--blue);
}

.fc-bgevent__presence {
  background-color: #beddff;
}

.fc-bgevent__presence {
  background: rgba(153, 197, 244, 0.7098) !important;
  border-radius: 0 !important;
}

.d-event--canceled {
  background-color: #fff !important;
  background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' preserveAspectRatio='none' viewBox='0 0 100 100'><path d='M100 0 L0 100 ' stroke='red' stroke-width='2'/><path d='M0 0 L100 100 ' stroke='red' stroke-width='2'/></svg>");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%, auto;
}

.d-event--canceled .fc-content {
  position: relative;
  color: #222;
}

.d-event--canceled:before {
  content: attr(data-label);
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1212;
  background-color: #fddddd;
  color: #c20006;
  padding: 2px 4px;
  border-radius: 0 4px 0 4px;
}

@media print {
  .black-and-white .fc-event {
    background: #ffffff !important;
    color: #000000 !important;
    page-break-inside: avoid;
    border: 1px solid #000000 !important;
  }
}

</style>



// WEBPACK FOOTER //
// FullCal.vue?1a42687e